<template>
  <div id="home">
    <header>
      <canvas id="animate"></canvas>
      <div class="title-wrapper">
        <img ref="imgTitle" src="../assets/img/title.png">
      </div>
      <div class="linkbox-wrapper">
        <div class="linkbox">
          <div
            class="box-item left"
            :class="{ active: activeItem === 0 }"
            @mouseover="() => activeItem = 0"
            @click="jump(0)"
          >
            <div class="title">国内供应商合作</div>
            <p>国内商家首选的精品零售平台，欢迎优质品牌商和供应商入驻。</p>
            <a class="link-button">立即入驻 <i class="el-icon-arrow-right"></i></a>
          </div>
          <div
            class="box-item right"
            :class="{ active: activeItem === 1 }"
            @mouseover="() => activeItem = 1"
            @click="jump(1)"
          >
            <div class="title">跨境供应商合作</div>
            <p>跨境电商平台，为有品用户提供全球品质新奇好物。</p>
            <a class="link-button">立即入驻 <i class="el-icon-arrow-right"></i></a>
          </div>
        </div>
      </div>
      <div class="arc-mask"></div>
      <div class="mask-bottom"></div>
    </header>

    <main>
      <!-- 商家入驻流程 -->
      <section class="merchant-settled">
        <h2>商家入驻流程</h2>
        <h3>MERCHANT SETTLED</h3>
        <div class="flex-row">
          <div class="settled-box box1">
            <div class="icon"></div>
            <div class="title">入驻准备</div>
            <ol type="1">
              <li>注册小米个人用户账号</li>
              <li><a @click="jumpTo('/rule')">查询入驻所需资料</a></li>
              <li>根据供应商类型点击【立即入驻】按钮</li>
            </ol>
          </div>
          <div class="settled-box box2">
            <div class="icon"></div>
            <div class="title">资质填写及审核</div>
            <ol>
              <li>填写联系人信息、企业资质、品牌资质、类目资质</li>
              <li>提交后进入平台审核阶段，一般2-3个工作日内反馈审核结果</li>
              <li><a @click="jumpTo('/apply')">查询入驻审核进度</a></li>
            </ol>
          </div>
          <div class="settled-box box3">
            <div class="icon"></div>
            <div class="title">合作协议签署</div>
            <ol>
              <li>确认合作协议内容并完成签署</li>
              <li>协议签署完成后入驻成功</li>
            </ol>
          </div>
          <div class="settled-box box4">
            <div class="icon"></div>
            <div class="title">开店选品</div>
            <ol>
              <li>登录商家后台查看操作指南</li>
              <li>登录选品系统，开始上架商品</li>
            </ol>
          </div>
        </div>
        <div class="button-row">
          <div class="button" @click="jumpTo('/process')">查看详细入驻流程 <i class="el-icon-arrow-right"></i></div>
        </div>
      </section>

      <!-- 我们为您提供 -->
      <section class="provide">
        <h2>我们为您提供</h2>
        <h3>PROVIDE</h3>
        <div class="flex-row">
          <div class="box blue"></div>
          <div class="box red"></div>
          <div class="box yellow"></div>
        </div>
      </section>

      <!-- 成功案例 -->
      <section class="success-case">
        <h2>成功案例</h2>
        <h3>SUCCESS CASE</h3>
        <div class="carousel">
          <swiper ref="swiper" :options="swiperOptions">
            <swiper-slide>
              <a href="https://www.xiaomiyoupin.com/detail?gid=119306" target="_blank">
                <img src="../assets/img/case_9.png">
              </a>
            </swiper-slide>
            <swiper-slide>
              <a href="https://www.xiaomiyoupin.com/detail?gid=137872" target="_blank">
                <img src="../assets/img/case_10.png">
              </a>
            </swiper-slide>
            <swiper-slide>
              <a href="https://www.xiaomiyoupin.com/detail?gid=138029" target="_blank">
                <img src="../assets/img/case_1.png">
              </a>
            </swiper-slide>
            <swiper-slide>
              <a href="https://www.xiaomiyoupin.com/detail?gid=109289" target="_blank">
                <img src="../assets/img/case_15.png">
              </a>
            </swiper-slide>
            <swiper-slide>
              <a href="https://www.xiaomiyoupin.com/detail?gid=134164" target="_blank">
                <img src="../assets/img/case_2.png">
              </a>
            </swiper-slide>
            <swiper-slide>
              <a href="https://www.xiaomiyoupin.com/detail?gid=129105" target="_blank">
                <img src="../assets/img/case_3.png">
              </a>
            </swiper-slide>
            <swiper-slide>
              <a href="https://www.xiaomiyoupin.com/detail?gid=136371" target="_blank">
                <img src="../assets/img/case_4.png">
              </a>
            </swiper-slide>
            <!-- <swiper-slide>
              <a href="https://www.xiaomiyoupin.com/detail?gid=133868" target="_blank">
                <img src="../assets/img/case_5.png">
              </a>
            </swiper-slide> -->
            <swiper-slide>
              <a href="https://www.xiaomiyoupin.com/detail?gid=136552" target="_blank">
                <img src="../assets/img/case_6.png">
              </a>
            </swiper-slide>
            <swiper-slide>
              <a href="https://www.xiaomiyoupin.com/detail?gid=106688" target="_blank">
                <img src="../assets/img/case_7.png">
              </a>
            </swiper-slide>
            <swiper-slide>
              <a href="https://www.xiaomiyoupin.com/detail?gid=126542" target="_blank">
                <img src="../assets/img/case_8.png">
              </a>
            </swiper-slide>
            <swiper-slide>
              <a href="https://www.xiaomiyoupin.com/detail?gid=133504" target="_blank">
                <img src="../assets/img/case_11.png">
              </a>
            </swiper-slide>
            <swiper-slide>
              <a href="https://www.xiaomiyoupin.com/detail?gid=137072" target="_blank">
                <img src="../assets/img/case_12.png">
              </a>
            </swiper-slide>
            <swiper-slide>
              <a href="https://www.xiaomiyoupin.com/detail?gid=111293" target="_blank">
                <img src="../assets/img/case_13.png">
              </a>
            </swiper-slide>
            <swiper-slide>
              <a href="https://www.xiaomiyoupin.com/detail?gid=134057" target="_blank">
                <img src="../assets/img/case_14.png">
              </a>
            </swiper-slide>
          </swiper>
          <div class="swiper-control">
            <div slot="button-prev" class="swiper-button-prev" @click="handleSlide(true)"></div>
            <div slot="button-next" class="swiper-button-next" @click="handleSlide(false)"></div>
          </div>
        </div>
        <div class="trademarks">
          <div class="item-row">
            <a href="https://m.xiaomiyoupin.com/w/spchome?id=wze5v5HeGQsscU28hN3qsQ" target="_blank">
              <img class="normal" src="../assets/img/logo_01.png">
              <img class="hover" src="../assets/img/logo_01_hover.png">
            </a>
            <a href="https://m.xiaomiyoupin.com/w/spchome?id=nhu1RTNwNWw-46udX41Ecg" target="_blank">
              <img class="normal" src="../assets/img/logo_02.png">
              <img class="hover" src="../assets/img/logo_02_hover.png">
            </a>
            <a href="https://m.xiaomiyoupin.com/w/spchome?id=TTCxi-Q10OPhDAk6Maqgvg" target="_blank">
              <img class="normal" src="../assets/img/logo_03.png">
              <img class="hover" src="../assets/img/logo_03_hover.png">
            </a>
            <a href="https://m.xiaomiyoupin.com/w/spchome?id=v-9dKyjIiNbQl1nO3Xy_GA" target="_blank">
              <img class="normal" src="../assets/img/logo_04.png">
              <img class="hover" src="../assets/img/logo_04_hover.png">
            </a>
            <a href="https://m.xiaomiyoupin.com/w/spchome?id=3vejlxT-wdhkf6vhEWfesg" target="_blank">
              <img class="normal" src="../assets/img/logo_05.png">
              <img class="hover" src="../assets/img/logo_05_hover.png">
            </a>
            <a href="https://m.xiaomiyoupin.com/w/spchome?id=fYqeIvZqwhpMrYj_fSRAsQ" target="_blank">
              <img class="normal" src="../assets/img/logo_06.png">
              <img class="hover" src="../assets/img/logo_06_hover.png">
            </a>
          </div>
          <div class="item-row">
            <a href="https://m.xiaomiyoupin.com/w/spchome?id=cI3GpXg2s9jPjS-749Q0JA" target="_blank">
              <img class="normal" src="../assets/img/logo_07.png">
              <img class="hover" src="../assets/img/logo_07_hover.png">
            </a>
            <a href="https://m.xiaomiyoupin.com/w/spchome?id=rqINQFXwLmr6FoE6d27mDw" target="_blank">
              <img class="normal" src="../assets/img/logo_08.png">
              <img class="hover" src="../assets/img/logo_08_hover.png">
            </a>
            <a href="https://m.xiaomiyoupin.com/w/spchome?id=rz3F6QPiy7U_o1C-nf8IjA" target="_blank">
              <img class="normal" src="../assets/img/logo_09.png">
              <img class="hover" src="../assets/img/logo_09_hover.png">
            </a>
            <a href="https://m.xiaomiyoupin.com/w/spchome?id=XI6RgwEBUICwguB70f-3uw" target="_blank">
              <img class="normal" src="../assets/img/logo_10.png">
              <img class="hover" src="../assets/img/logo_10_hover.png">
            </a>
            <a href="https://m.xiaomiyoupin.com/w/spchome?id=OV-vhAsYaTODq2xLHDWwHA" target="_blank">
              <img class="normal" src="../assets/img/logo_11.png">
              <img class="hover" src="../assets/img/logo_11_hover.png">
            </a>
            <a href="https://m.xiaomiyoupin.com/w/spchome?id=jXY6nPxjWOeLzR25xrmklA" target="_blank">
              <img class="normal" src="../assets/img/logo_12.png">
              <img class="hover" src="../assets/img/logo_12_hover.png">
            </a>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import animate from '@/components/animation'
import { mapMutations } from 'vuex'

export default {
  data() {
    return {
      demoIndex: 2,
      activeItem: 0,
      demo2: {
        colors: ['#ffeaa3', '#91bbff', '#ffc9d0', '#ffdca8', '#abd1ff', '#ffbdc4'],
        opacity: 0.6
      },
      swiperOptions: {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 18,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  mounted() {
    animate()
  },
  methods: {
    ...mapMutations({
      setIsOverseas: 'SET_ISOVERSEAS'
    }),
    /**
     * 链接跳转
     * @param {Number} index 0：入驻国内商家 1：入驻海淘商家
     */
    jump(index) {
      if (index === 0) {
        this.setIsOverseas(false)
        this.$router.push({ path: '/apply' })
      } else if (index === 1) {
        this.setIsOverseas(true)
        this.$router.push({ path: '/apply' })
      }
    },
    /**
     * 跳转到链接
     * @param {string} path
     */
    jumpTo(path) {
      this.$router.push(path)
    },
    /**
     * 轮播按钮点击
     * @param {boolean} prev 上一页
     */
    handleSlide(prev = false) {
      const swiper = this.$refs.swiper.swiperInstance
      prev ? swiper.slidePrev() : swiper.slideNext()
    }
  }
}
</script>

<style lang="less">
.vue-dat-gui {
  top: 60px !important;
  right: 0 !important;
}

#home {
  margin-top: -60px;

  header {
    height: 600px;
    min-width: 1200px;
    position: relative;
    overflow: hidden;

    canvas {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      width: 100vw;
      min-width: 1200px;
      height: 1200px;
      z-index: -1;
    }

    .title-wrapper {
      margin-top: 143px;
      display: flex;
      justify-content: center;
    }

    .linkbox-wrapper {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
      display: flex;
      justify-content: center;
    }

    .linkbox {
      display: flex;
      width: 830px;

      .box-item {
        width: 415px;
        text-align: center;
        border-radius: 12px;
        cursor: pointer;

        .title {
          font-size: 21px;
          line-height: 29px;
          font-weight: 500;
        }

        p {
          width: 250px;
          margin: 0 auto;
          margin-top: 6px;
          text-align: left;
          font-size: 17px;
          line-height: 24px;
        }

        .link-button {
          display: block;
          width: 140px;
          height: 40px;
          margin: 0 auto;
          margin-top: 24px;
          line-height: 41px;
          text-align: center;
          font-size: 17px;
          border-radius: 5px;
          font-weight: 500;
          transition: all 0.3s ease-out;
          cursor: pointer;

          &:hover {
            opacity: 0.8;
          }

          i {
            font-weight: 900;
          }
        }
      }

      .left,
      .right {
        height: 218px;
        margin-top: 10px;
        background: #fff;
        color: #333;
        cursor: pointer;
        transition: all 0.3s ease-out;

        .title {
          margin-top: 39px;
          transition: all 0.3s ease-out;
        }

        .link-button {
          background: #708CFD;
          color: #fff;
          transition: all 0.3s ease-out;
        }
      }

      .active {
        height: 238px;
        margin-top: 0;
        background: #355BF4;
        color: #fff;

        .left {
          border-radius: 12px 0 0 12px;
        }

        .right {
          border-radius: 0 12px 12px 0;
        }

        .title {
          margin-top: 49px
        }

        .link-button {
          color: #4669F7;
          background: #fff;
        }
      }
    }

    .arc-mask {
      position: absolute;
      bottom: 105px;
      height: 50px;
      left: 0;
      right: 0;
      background: url(../assets/svg/home_mask.svg) no-repeat;
      background-size: 100% 100%;
    }

    .mask-bottom {
      position: absolute;
      bottom: 0;
      height: 105px;
      left: 0;
      right: 0;
      background: #F2F8FF;
    }
  }

  main {
    section {
      min-width: 1200px;
      position: relative;

      h2 {
        margin-top: 0;
        margin-bottom: 0;
        padding-top: 60px;
        line-height: 36px;;
        font-size: 25px;
        color: #06003B;
        letter-spacing: 3px;
        text-align: center;

        &::before {
          content: '·';
          padding-right: 5px;
        }

        &::after {
          content: '·';
          padding-left: 5px;
        }
      }

      h3 {
        font-size: 13px;
        color: #06003B;
        letter-spacing: 0;
        text-align: center;
        font-weight: 100;
      }
    }
  }

  .merchant-settled {
    height: 643px;
    background: #F2F8FF;

    .flex-row {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      margin-top: 78px;

      .settled-box {
        width: 270px;
        height: 290px;

        @nums: 1,2,3,4;
        each(@nums, {
          &.box@{value} {
            position: relative;
            background: url("../assets/img/bg_settled_@{value}.png");

            .icon {
              height: 88px;
              position: absolute;
              top: -31px;
              left: 0;
              right: 0;
              background: url("../assets/img/icon_settled_@{value}.png") no-repeat;
              background-position: center;
            }

            .title {
              margin-top: 69px;
              line-height: 33px;
              font-size: 24px;
              color: #333333;
              letter-spacing: 0;
              text-align: center;
              font-weight: 500;
            }

            ol {
              padding: 0 24px 0 40px;
            }

            li {
              list-style: decimal;
              font-size: 15px;
              color: #333333;
              letter-spacing: 0;
              line-height: 32px;
              text-indent: 2px;

              a {
                color: #4669F7;
                text-decoration: underline;
                cursor: pointer;
              }
            }
          }
        });
      }
    }

    .button-row {
      width: 1200px;
      margin: 0 auto;
      margin-top: 42px;

      .button {
        width: 232px;
        height: 48px;
        line-height: 48px;
        border-radius: 9px;
        text-align: center;
        margin: 0 auto;
        border: 1px solid #4669F7;
        color: #4669F7;
        font-size: 19px;
        letter-spacing: 0;
        cursor: pointer;
        user-select: none;
      }
    }
  }

  .provide {
    height: 589px;
    background: #fff;

    .flex-row {
      width: 1078px;
      height: 350px;
      margin: 0 auto;
      margin-top: 56px;
      display: flex;
      justify-content: space-between;

      .box {
        width: 303px;
        height: 344px;
        background-size: 100% 100%;

        @blue: #3D50E1;
        @red: #FF5971;
        @yellow: #FD9905;

        &.blue {
          color: @blue;
          background: url(../assets/img/bg_hexagon_1.png) no-repeat;
        }

        &.red {
          color: @red;
          background: url(../assets/img/bg_hexagon_2.png) no-repeat;
        }

        &.yellow {
          color: @yellow;
          background: url(../assets/img/bg_hexagon_3.png) no-repeat;
        }

        .title {
          margin-top: 80px;
          font-size: 24px;
          line-height: 33px;
          letter-spacing: 0;
          text-align: center;
          font-weight: 500;
        }

        hr {
          width: 46px;
          height: 3px;
          border: none;
          margin-top: 24px;
          margin-bottom: 0;
          border-radius: 2px;
          opacity: 0.4;
        }

        p {
          margin-top: 24px;
          padding: 0 30px;
          text-align: center;
          font-size: 17px;
          line-height: 24px;
          letter-spacing: 0;
          opacity: 0.8;
        }
      }
    }
  }

  .success-case {
    height: 993px;
    background: #F2F8FF;

    .carousel {
      width: 1078px;
      margin: 0 auto;
      margin-top: 56px;
      position: relative;

      img {
        display: inline-block;
        width: 256px;
        height: 316px;
      }

      .swiper-control {
        position: absolute;
        width: 1078px;
        top: 150px;
        z-index: 0;

        .swiper-button-prev {
          margin-left: -80px;
          color: #ccc;
          font-weight: 900;
        }

        .swiper-button-next {
          margin-right: -70px;
          color: #ccc;
          font-weight: 900;
        }
      }
    }

    .trademarks {
      width: 1078px;
      margin: 0 auto;
      margin-top: 30px;
      padding: 25px;
      background: #fff;
      box-sizing: border-box;
      border-radius: 12px;

      .item-row {
        display: flex;
        justify-content: space-between;
        position: relative;

        a {
          position: relative;
          display: block;
          width: 130px;
          height: 130px;

          img {
            width: 130px;
            height: 130px;
            position: absolute;
            left: 0;
            top: 0;
            opacity: 1;
            transition: all 0.3s ease-out;

            &.normal {
              opacity: 1;
            }

            &.hover {
              opacity: 0;
            }
          }

          & > .normal:hover {
            opacity: 0;
          }

          & > .hover:hover {
            opacity: 1;
          }
        }
      }
    }
  }

  .test-box {
    position: absolute;
    top: 100px;
    left: 20px;
    width: 64px;
    z-index: 100;
    background: #666;
    padding: 10px;
    border-radius: 6px;

    .title {
      font-size: 12px;
      text-align: center;
      margin-bottom: 5px;
      color: #fff;
    }

    .item {
      margin-bottom: 5px;
      background: #333;
      color: #fff;
      text-align: center;
      font-size: 12px;
      line-height: 24px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease-out;
      border: 1px solid #fff;

      &.active {
        background: #ff6a7f;
      }

      &:hover {
        background: #fff;
        color: #000;
        border: 1px solid #000;
      }
    }
  }
}
</style>
